// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-production-chart {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.operator-production-chart__canvas {
  width: 100%;
  transition: opacity 0.2s ease, min-height 0.2s ease;
}

.operator-chart-overlay,
.operator-production-chart__empty-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(2px);
}

.operator-chart-loader {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.operator-chart-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #dbe4f0;
  border-top-color: #2f539d;
  border-radius: 50%;
  animation: operator-chart-spin 0.7s linear infinite;
}

.operator-production-chart__empty-overlay {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
  background: #ffffff;
}

@keyframes operator-chart-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/components/OperatorProductionChart.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mDACE;AAAJ;;AAIA;;EAEE,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,qCAAA;EACA,0BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,mDAAA;AANF;;AASA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AASA;EACE;IACE,yBAAA;EANF;AACF","sourcesContent":[".operator-production-chart {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.operator-production-chart__canvas {\n  width: 100%;\n  transition:\n    opacity 0.2s ease,\n    min-height 0.2s ease;\n}\n\n.operator-chart-overlay,\n.operator-production-chart__empty-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(2px);\n}\n\n.operator-chart-loader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.operator-chart-spinner {\n  width: 20px;\n  height: 20px;\n\n  border: 3px solid #dbe4f0;\n  border-top-color: #2f539d;\n  border-radius: 50%;\n\n  animation: operator-chart-spin 0.7s linear infinite;\n}\n\n.operator-production-chart__empty-overlay {\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 600;\n  background: #ffffff;\n}\n\n@keyframes operator-chart-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
